module.exports = __webpack_public_path__ + "img/css.fd2c10ae.svg";